import React, { useState } from "react";
import { CalendarIcon } from "@radix-ui/react-icons";
import { format } from "date-fns";
import { Button } from "./Button";
import { Calendar } from "./Calender";
import { Popover, PopoverContent, PopoverTrigger } from "./Popover";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function DatePickerWithRange({ className, onChange }) {
  const today = new Date();
  const [date, setDate] = useState(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false); // Track popover state

  const handleDateSelect = (newDate) => {
    setDate(newDate);
    onChange(newDate);

    // Close the popover when a range is selected
    if (newDate?.from && newDate?.to) {
      setIsPopoverOpen(false);
    }
  };

  return (
    <div className={classNames("grid gap-2", className)}>
      <Popover open={isPopoverOpen} onOpenChange={setIsPopoverOpen}>
        <PopoverTrigger asChild>
          <Button
            id="date"
            variant={"outline"}
            className={classNames(
              "w-[300px] justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className="mr-2 h-4 w-4" />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto h-auto p-0" align="start">
          <Calendar
            initialFocus
            mode="range"
            defaultMonth={date?.from}
            selected={date}
            onSelect={handleDateSelect} // Call the updated handler
            numberOfMonths={1}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}

export { DatePickerWithRange };